<template>
  <li class="ten-file-item">
    <slot>
      <div class="ten-file-item__info">
        <div
          class="ten-file-item__info-filename"
          @click="onPreview"
        >
          {{ name }}
        </div>
        <ten-icon
          :icon="statusIcon"
          :class="[
            'ten-file-item__info-status-icon',
            {
              'ten-file-item__info-status-icon--loading': status === FILE_STATUS.LOADING,
              'ten-file-item__info-status-icon--error': status === FILE_STATUS.ERROR,
              'ten-file-item__info-status-icon--done': status === FILE_STATUS.DONE,
              'ten-file-item__info-status-icon--ready': status === FILE_STATUS.READY
            }
          ]"
        />
        <ten-icon
          class="ten-file-item__info-close-icon"
          icon="circle_clear"
          @click="onRemove"
        />
      </div>
      <ten-progress
        v-show="status === FILE_STATUS.LOADING"
        class="ten-file-item__progress"
        :inline="false"
        :value="progress"
      />
    </slot>
  </li>
</template>

<script>
import Icon from '../icon';
import Progress from '../progress';

const FILE_STATUS = {
  ERROR: 'error',
  DONE: 'done',
  LOADING: 'loading',
};

const STATUS_ICON = {
  ERROR: 'circle_clear',
  DONE: 'circle_tick',
  LOADING: 'loading_gradient',
};

export default {
  components: {
    TenIcon: Icon,
    TenProgress: Progress,
  },
  props: {
    progress: { type: Number, default: 0 },
    status: { type: String, default: FILE_STATUS.DONE },
    name: String,
  },
  data() {
    return { FILE_STATUS };
  },
  computed: {
    statusIcon() {
      return STATUS_ICON[this.status ? this.status.toUpperCase() : FILE_STATUS.DONE];
    },
  },
  methods: {
    onRemove(e) {
      e.preventDefault();
      this.$emit('file-list-item:remove');
    },
    onPreview() {
      this.$emit('file-list-item:preview');
    },
  },
};
</script>
